import React from 'react'
import { useCommand } from '~/client/hooks/cqrpc'
import { postToURL } from '~/client/lib/http.js'

export function useLoginToAppAccount(options){
  // call({ appAccountId, returnTo })
  return useCommand('appAccountLoginTokens.create', {
    ...options,
    onSuccess(result){
      postToURL(result.loginUrl)
    }
  })
}
